import React, {Component} from 'react';
import {observer} from 'mobx-react';
import styles from './index.css';
import fonts from '../../../../../iconfonts.css';
import {Popup} from '../index';
import FontAwesome from 'react-fontawesome';
import cultureSettings from '../../../../stores/cultureSettings'

@observer
export default class Truck extends Component{
    static defaultProps={
        deleteTransport:()=>{console.log('none event')},
        item:{transportStatus:'none',moistureLevel:0,wasteLevel:0,culture:'soy',groupQuantity:10,amount:0}
    };

    state = {active:false};

    coords(e){
        let target = e.target;
        let X = target.getBoundingClientRect().right + 5;
        let Y = target.getBoundingClientRect().top - 10;
        this.setState({active:true,x:X,y:Y})
    }

  render(){
  let item = this.props.item;
  let truckLevel = {height: (item.amount*0.14375)/(cultureSettings[item.culture].volume) + 'rem'};
  return(
    <div style={{position:'relative'}}>
        {item.transportStatus === 'alert' ? <div className={styles.deleteClickZone}  onMouseDown={(e)=>{e.stopPropagation();this.props.deleteTransport(this.props.id)}}/> : ''}
        <div className={styles.truckContainer} onMouseOver={this.coords.bind(this)} onMouseLeave={()=>this.setState({active:false})}>
      <div className={styles.truck}>
        <div className={styles.truckStatus + (item.transportStatus ? ' ' + styles[item.transportStatus] : '') + ' ' + (this.props.backwards ? '' : styles.statusForvard)} />
        <div className={ this.props.backwards ? styles.cultureArea : styles.cultureAreaForvard }>
          <div className={styles.truckLevel + (item.culture ? ' ' + styles[item.culture] : '')} style={truckLevel}>
          </div>
          <div className={styles.truckCulture}>
            <i className={fonts[item.culture]} />
          </div>
          <div className={styles.truckNumbers}>
            <span>{item.moistureLevel}%</span>
            <span>{item.wasteLevel}%</span>
          </div>
          <div className={(item.groupQuantity > 1 ? styles.truckQuantity : styles.hideQuantity)}>{item.groupQuantity}</div>
          <div className={styles.truckDefinitions}>
            <span><FontAwesome name='tint'/></span>
            <span><FontAwesome name='trash'/></span>
          </div>
        </div>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 140 50">
          <path className={ this.props.backwards ? styles.truckBase : styles.hiddenPath } d="M32,25V0h-3l-4,5h-8l-4,8L0,16v14h3v2h2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h17c0,4.4,3.6,8,8,8s8-3.6,8-8h2
          c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-5h26v5h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-7H32z M13,36c-2.2,0-4-1.8-4-4
          s1.8-4,4-4c2.2,0,4,1.8,4,4S15.2,36,13,36z M46,36c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S48.2,36,46,36z M64,36c-2.2,0-4-1.8-4-4
          s1.8-4,4-4s4,1.8,4,4S66.2,36,64,36z M110,36c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S112.2,36,110,36z M128,36c-2.2,0-4-1.8-4-4
          s1.8-4,4-4s4,1.8,4,4S130.2,36,128,36z"/>

          <path className={ this.props.backwards ? styles.hiddenPath : styles.truckBase } d="M0,25l0,7h2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-5h26v5h2c0,4.4,3.6,8,8,8
          s8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h17c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h2v-2h3V16l-13-3l-4-8h-8l-4-5l-3,0v25H0z M121,32
          c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S121,34.2,121,32z M88,32c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C89.8,36,88,34.2,88,32z
          M70,32c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S70,34.2,70,32z M24,32c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S24,34.2,24,32z M6,32
          c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S6,34.2,6,32z"/>
        </svg>
      </div>
      {/*<div className={styles.truckPopup}>*/}
        {/*x*/}
      {/*</div>*/}
        {this.state.active ?
            <Popup x={this.state.x} y={this.state.y} item={item} /> : null
        }

    </div>
    </div>
  )}
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Truck/index.js